import React from "react";
import ReactCountryFlag from "react-country-flag";

export function GeoColumnFormatter(cellContent, row) {
  return (
    <>
      <ReactCountryFlag
        svg
        style={{
          width: "2em",
          height: "2em",
        }}
        title={row.code}
        countryCode={row.code}
      />
    </>
  );
}
